import React from "react";
const StatusText = ({ title, subTitle, preTitle }) => (
  <div className={"status-text"}>
    {preTitle ? <div className="pretitle">{preTitle}</div> : null}
    {title ? <div className="title">{title}</div> : null}
    {subTitle ? <div className="subtitle">{subTitle}</div> : null}
  </div>
);

export default StatusText;
